// Collateral Damage (Mars): every blocked star is worth points to the play.
import { ALIGNMENT_NUMBERS as N } from '../constants';
import type { AlignmentDef } from '../types';

export const collateralDamage: AlignmentDef = {
  id: 'collateral-damage',
  planet: 'mars',
  name: 'Collateral Damage',
  text: () => `Each blocked star is worth +${N.collateralEach} points.`,
  playAdd: (ctx) => ({ label: 'Blocked stars', count: ctx.derived.blocked.size, each: N.collateralEach }),
};
